import { Component } from '@angular/core';
import { SavedCartService } from '@spartacus/cart/saved-cart/core';

@Component({
  selector: 'app-custom-saved-cart',
  standalone: false,
  templateUrl: './custom-saved-cart.component.html',
  styleUrls: ['./custom-saved-cart.component.scss'],
})
export class CustomSavedCartComponent {
  constructor(private savedCartService: SavedCartService) {
    this.savedCartService.loadSavedCarts();
  }

  savedCart$ = this.savedCartService.getList();
}
